import React from "react";
import { RadioButtonOption } from "../../common/enums";
import Resources from "../../types/Resources";
import RadioButton from "./RadioButton";

type ChecklistRadioOptionsProps = {
    id: string;
    value: RadioButtonOption;
    onChange: (updatedValue: RadioButtonOption) => void;
    labelText: string | undefined;
    resources: Resources;
    hideNotApplicable?: boolean;
    readOnly: boolean;
};

function ChecklistRadioOptions(props: ChecklistRadioOptionsProps) {
    return (
        <div className="d-flex justify-content-between form-group">
            <div>{props.labelText}</div>
            <div id={props.id} className="d-flex">
                <RadioButton
                    checked={props.value === RadioButtonOption.Yes}
                    onSelect={() => props.onChange(RadioButtonOption.Yes)}
                    label={props.resources.get("Yes")}
                    readOnly={props.readOnly}
                    inputId={`${props.id}_yes`}
                    name={props.id}
                    containerClassName="me-4"
                />

                <RadioButton
                    checked={props.value === RadioButtonOption.No}
                    onSelect={() => props.onChange(RadioButtonOption.No)}
                    label={props.resources.get("No")}
                    readOnly={props.readOnly}
                    inputId={`${props.id}_no`}
                    name={props.id}
                    containerClassName="me-4"
                />

                {props.hideNotApplicable ? null : (
                    <RadioButton
                        checked={props.value === RadioButtonOption.NotApplicable}
                        onSelect={() => props.onChange(RadioButtonOption.NotApplicable)}
                        label={props.resources.get("NotApplicable")}
                        readOnly={props.readOnly}
                        inputId={`${props.id}_notApplicable`}
                        name={props.id}
                    />
                )}
            </div>
        </div>
    );
}

export default ChecklistRadioOptions;
